export const ACTIVATE_PROCESS_ERROR = "ACTIVATE_PROCESS_ERROR"
export const ACTIVATE_PROCESS_NOT_PROCESSING = "ACTIVATE_PROCESS_NOT_PROCESSING"
export const ACTIVATE_PROCESS_PROCESSING = "ACTIVATE_PROCESS_PROCESSING"
export const ACTIVATE_PROCESS_INIT = "ACTIVATE_PROCESS_INIT"
export const ACTIVATE_PROCESS_DONE = "ACTIVATE_PROCESS_DONE"
